import { css } from '@emotion/core'
import { colors, spacing } from 'styles/variables'

export const headerContainer = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: #000000;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`

export const header = css`
  display: flex;
  align-items: center;
  padding: ${spacing(4)} ${spacing(2)};
  background-color: #000000;
  position: relative;
`

export const backArrow = css`
  color: #ffffff;
  font-size: 22px;
  cursor: pointer;
  user-select: none;
  position: absolute;
  left: ${spacing(2)};
  top: 50%;
  transform: translateY(-50%);
  margin-top: 5px;
`

export const titleContainer = css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  margin-top: 6px;
  margin-left: -37.5px;
`

export const tournamentTitle = css`
  color: ${colors.white100};
  margin: 0;
  font-weight: 600;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

export const calendarIcon = css`
  color: #ffffff;
  font-size: 16px;
  margin-left: ${spacing(1)};
`

export const calendarIconRight = css`
  color: #ffffff;
  font-size: 16px;
  position: absolute;
  right: ${spacing(2)};
  top: 50%;
  transform: translateY(-50%);
  margin-top: 5px;
  cursor: pointer;
  user-select: none;
`

export const tabsContainer = css`
  display: flex;
  padding: ${spacing(2)} ${spacing(2)};
  background-color: #000000;
`

export const tabsWrapper = css`
  display: flex;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: ${spacing(3)};
  padding: ${spacing(0.375)};
  gap: ${spacing(0.1875)};
  width: 100%;
`

export const tab = css`
  flex: 1;
  background-color: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  padding: ${spacing(1.125)} ${spacing(1.5)};
  cursor: pointer;
  border-radius: ${spacing(2.625)};
  transition: all 0.2s ease;
  text-align: center;
  min-height: 33px;
  font-size: 12px;
  font-weight: 500;
  
  &:hover {
    color: rgba(255, 255, 255, 0.9);
  }
`

export const activeTab = css`
  background-color: #6FCF97;
  color: #1a1a1a;
  font-weight: 600;
  
  &:hover {
    background-color: #6FCF97;
    color: #1a1a1a;
  }
`

export const tabText = css`
  margin: 0;
  font-weight: inherit;
  color: inherit;
`

export const activeTabText = css`
  color: #000000 !important;
`

export const loadingTabs = css`
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
  padding: ${spacing(1.125)};
  width: 100%;
` 